<template>
    <div :class="[{'pa-0 mb-15': $vuetify.breakpoint.smAndDown},
                  {'px-3 py-4': $vuetify.breakpoint.mdAndUp}]">
        <spiel-berichte-offen-waiting v-if="!isSpielFremdAdmin" :class="[{'mx-0': $vuetify.breakpoint.smAndDown},
                                                {'mb-5': $vuetify.breakpoint.mdAndUp} ]">
        </spiel-berichte-offen-waiting>
        <spiel-berichte-offen-created>
        </spiel-berichte-offen-created>
    </div>
</template>

<script>
    import SpielBerichteOffenCreated from "./spielBerichteOffenCreated";
    import SpielBerichteOffenWaiting from "./spielBerichteOffenWaiting";

    export default {
        components: {
            SpielBerichteOffenWaiting,
            SpielBerichteOffenCreated},
        name: "spiel-berichte-offen",
        props: ['isSpielFremdAdmin'],
    }
</script>

<style scoped>

</style>